import { createSlice } from '@reduxjs/toolkit';
import ProbeApiService from '../provider/redux/query/probe.service';
const initialState = {
  wifiProbes: [],
  totalRecords: 0,
  page: 1,
};

const wifiProbeSlice = createSlice({
  name: 'wifiProbes',
  initialState,
  extraReducers: builder => {
    builder
      .addMatcher(ProbeApiService.endpoints.getWifiProbes.matchFulfilled, (state, action) => {
        // console.log('================================');
        // console.log('getWifiProbes [matchFulfilled] =>', action.payload);
        // console.log('================================');
        const { totalRecords, wifi_probes } = action.payload.data;
        state.wifiProbes = wifi_probes;
        state.totalRecords = totalRecords;
        state.loading = false;
      })
      .addMatcher(ProbeApiService.endpoints.getWifiProbes.matchPending, state => {
        state.loading = true;
      })
      .addMatcher(ProbeApiService.endpoints.getWifiProbes.matchRejected, state => {
        state.loading = false;
      });
  },
});

export default wifiProbeSlice;
